"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
interface CredentialItem {
  id: number;
  src: string;
  srcset: string;
  sizes: string;
  alt: string;
  scaleClass?: string;
}
const credentials: CredentialItem[] = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/faviconbrown.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/faviconbrown.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/faviconbrown.webp-wvc-sizes",
  alt: "SLOW MAMA Sceau d'accompagnement bienveillant",
  scaleClass: ""
}, {
  id: 2,
  src: "https://slow-mama.com/wp-content/uploads/2026/08/LOGO-scaled.png?v=bgd2t12caxm",
  srcset: "https://slow-mama.com/wp-content/uploads/2026/08/images.jpg?v=0973jdgs1wim",
  sizes: "https://slow-mama.com/wp-content/uploads/2026/08/images.jpg?v=c3u0ldf6cuw",
  alt: "Label et certification professionnelle",
  scaleClass: "scale-110 md:scale-120"
}, {
  id: 3,
  src: "https://slow-mama.com/wp-content/uploads/2026/08/images.png?v=ssevaicvmjr",
  srcset: "https://slow-mama.com/wp-content/uploads/2026/08/images.jpg?v=tdw44vzpkz",
  sizes: "https://slow-mama.com/wp-content/uploads/2026/08/images.jpg?v=ix4vegzv5p",
  alt: "Accréditation et certification partenaire",
  scaleClass: "scale-110 md:scale-120"
}];
export default function Credentials() {
  const prefersReducedMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: prefersReducedMotion ? 0 : 0.15,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: prefersReducedMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <section className="py-16 md:py-24 bg-background border-t border-border/30 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="flex flex-wrap items-center justify-around gap-8 md:gap-16">
          {credentials.map((item, i) => <motion.div key={item.id} data-index={i} variants={itemVariants} className="flex items-center justify-center p-2">
              <div className="w-32 h-32 md:w-44 md:h-44 flex items-center justify-center bg-card rounded-2xl shadow-xs p-4 md:p-6">
                <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className={`w-full h-full object-contain opacity-85 transition-[opacity] duration-300 hover:opacity-100 ${item.scaleClass || ""}`} />
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}